const setSportFilter = ({sportId, lastIndex}) => {
    const isIndex = lastIndex ? `[${lastIndex + 1}]` : '';

    return `&filters[$and]${isIndex}[sport][$eq]=${sportId}`;
};

export default setSportFilter;
